/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface RegenerateSecretResponse
 */
export interface RegenerateSecretResponse {
  /**
   *
   * @type {string}
   * @memberof RegenerateSecretResponse
   */
  secretKey: string;
}

/**
 * Check if a given object implements the RegenerateSecretResponse interface.
 */
export function instanceOfRegenerateSecretResponse(
  value: object,
): value is RegenerateSecretResponse {
  if (!("secretKey" in value) || value["secretKey"] === undefined) return false;
  return true;
}

export function RegenerateSecretResponseFromJSON(
  json: any,
): RegenerateSecretResponse {
  return RegenerateSecretResponseFromJSONTyped(json, false);
}

export function RegenerateSecretResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): RegenerateSecretResponse {
  if (json == null) {
    return json;
  }
  return {
    secretKey: json["secretKey"],
  };
}

export function RegenerateSecretResponseToJSON(
  json: any,
): RegenerateSecretResponse {
  return RegenerateSecretResponseToJSONTyped(json, false);
}

export function RegenerateSecretResponseToJSONTyped(
  value?: RegenerateSecretResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    secretKey: value["secretKey"],
  };
}
